import { LitElement, PropertyValues, css, html } from 'lit'
import { customElement, property, query, state } from 'lit/decorators.js'

/**
 * 자식 컴포넌트들을 그리드형태로 화면에 배치하여 한꺼번에 디스플레이해주는 컴포넌트.
 * Example:
    <ox-board-player-grid rows="3" columns="3" tabindex="0" focus>
      <div page>A</div>
      <div page>B</div>
      <div page>C</div>
      <div page>D</div>
    </ox-board-player-grid>
 */

@customElement('ox-board-player-grid')
class BoardPlayerGrid extends LitElement {
  static styles = [
    css`
      :host {
        width: 100%;
        height: 100%;
        position: relative;

        display: grid;
        grid-gap: 0px;
        grid-auto-flow: dense;
      }
    `
  ]

  @property({ type: Number }) rows: number = 1
  @property({ type: Number }) columns: number = 1

  @state() _slotObserver?: MutationObserver

  @query('#slot') _slot!: HTMLSlotElement

  render() {
    return html` <slot id="slot" select="[page]"></slot> `
  }

  async connectedCallback() {
    await super.connectedCallback()

    this._slotObserver = new MutationObserver(mutations => {
      var columns = this.columns || 1
      var rows = this.rows || 1

      ;(this.style as any)['grid-template-columns'] = `repeat(${columns}, 1fr)`
      ;(this.style as any)['grid-template-rows'] = `repeat(${rows}, 1fr)`
    })

    await this.updateComplete

    var columns = this.columns || 1
    var rows = this.rows || 1

    ;(this.style as any)['grid-template-columns'] = `repeat(${columns}, 1fr)`
    ;(this.style as any)['grid-template-rows'] = `repeat(${rows}, 1fr)`

    this._slotObserver?.observe(this._slot, { childList: true })
  }

  disconnectedCallback() {
    super.disconnectedCallback()

    this._slotObserver?.disconnect()
    delete this._slotObserver
  }

  start() {}

  stop() {}

  next() {}

  previous() {}
}
